/**
 * "Ver recibo e arquivos recebidos" na tela Enviar documentos (E165.F1.T03, HTML 6.8): recolhido,
 * dentro do card de arquivos, com o alcance curto e o "Ver recibo", que abre a consulta "Cadeia de
 * custódia" (`?vista=custodia`, E163.F3). É por aqui e pelo caso que o recibo, os originais, os
 * manifestos e os hashes continuam acessíveis: a custódia saiu do Conferir (GUS-202, ADR-0114 §3).
 */
import { useState } from 'react';

import { Button } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';

import { Recolhivel } from './PecasDaAbertura';

const t = ptBR.abertura.arquivos;

export function ReciboNoEnvio({ onVerRecibo }: { onVerRecibo: () => void }): JSX.Element {
  const [aberto, setAberto] = useState(false);
  return (
    <div className="mt-sc-4">
      <Recolhivel
        titulo={t.reciboTitulo}
        aberto={aberto}
        onAberto={setAberto}
        testId="abertura-recibo-no-envio"
      >
        <p className="text-[14px] text-fg">{t.reciboTexto}</p>
        <div>
          <Button
            type="button"
            variant="secondary"
            data-testid="abertura-ver-recibo"
            onClick={onVerRecibo}
          >
            {t.verRecibo}
          </Button>
        </div>
      </Recolhivel>
    </div>
  );
}
